/** API uses Newtonsoft without camelCase; map common fields to the shape the UI expects. */
export function normalizeOfficialLicenseGradeRow(raw: any) {
    if (raw == null || typeof raw !== "object") return raw;
    return {
        ...raw,
        id: raw.id ?? raw.Id,
        name: raw.name ?? raw.Name,
        officialLicenseTypeId: raw.officialLicenseTypeId ?? raw.OfficialLicenseTypeId,
        officialLicenseTypeName: raw.officialLicenseTypeName ?? raw.OfficialLicenseTypeName,
        price: raw.price ?? raw.Price,
        hasGardaVetting: raw.hasGardaVetting ?? raw.HasGardaVetting,
        licenseDurationValidityId: raw.licenseDurationValidityId ?? raw.LicenseDurationValidityId,
        durationValidityName: raw.durationValidityName ?? raw.DurationValidityName,
        gardaVettingDurationValidityId: raw.gardaVettingDurationValidityId ?? raw.GardaVettingDurationValidityId,
        gardaVettingDurationValidityName: raw.gardaVettingDurationValidityName ?? raw.GardaVettingDurationValidityName,
    };
}

export function normalizeOfficialLicenseGradeListPayload(payload: any) {
    if (payload == null) return { items: [], count: 0 };
    const items = payload.items ?? payload.Items;
    const count = payload.count ?? payload.Count;
    return {
        items: Array.isArray(items) ? items.map(normalizeOfficialLicenseGradeRow) : [],
        count: typeof count === "number" ? count : 0,
    };
}
